/**
 *  Skybox
 *
 *  Created by Legman on 31/03/2017.
 *
 */

import Common   from "./Common";

/**
 * @class
 */
export default class Skybox extends PIXI.Container {
    constructor() {
        super();

        this.createMainLayer();

        this.update(1);
    }

    resize() {
    }

    /**
     * @param {number} [ease]
     */
    update(ease) {
        ease = ease || 0.04;

        const engine = Common.engine;
        const camera = engine.camera;
        const target = camera.target;

        let angle = camera.angle;
        if (angle < 0) angle += (Math.PI * 2);
        if (angle > (Math.PI * 2)) angle -= (Math.PI * 2);
        angle /= (Math.PI * 2);

        this._mainLayer.x = -angle * this._mainLayer.tileWidth * this._mainLayer.tileCount;

        let diff = -40 + (engine.getTrackGradient(target.distance) * 240 * 2) - this._mainLayer.y;
        this._mainLayer.y += diff * ease;
    }

    /**
     */
    createMainLayer() {
        const assets = Common.assets;

        const texture = assets.getTexture("skybox");

        this._mainLayer = new PIXI.Container();
        this.addChild(this._mainLayer);

        const count = 3;

        let tile;
        for (let i = 0; i < count; ++ i) {
            tile = new PIXI.Sprite(texture);
            tile.anchor = new PIXI.Point(0.5, 0.5);
            this._mainLayer.addChild(tile);

            const aspectRatio = tile.width / tile.height;
            tile.width = p3.View.height * aspectRatio;
            tile.height = p3.View.height;

            tile.x = Common.STAGE_WIDTH * 0.5 + tile.width * i;
            tile.y = tile.height * 0.5;
        }

        this._mainLayer.tileWidth = tile.width;
        this._mainLayer.tileCount = count - 1;
    }
}
